import React from "react"
import styled, { useTheme } from "~/ui/styled"
import { Search, X } from "lucide-react"

interface SearchBarProps {
  value: string
  placeholder?: string
  style?: object
  onChange: (text: string) => void
  onClear?: () => void
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  placeholder = "搜索好友、群聊或频道",
  style = {},
  onChange,
  onClear,
}) => {
  const theme = useTheme()

  return (
    <Container style={style}>
      <IconBox>
        <Search size={18} color={theme.colors?.secondaryText || "#a2a8af"} />
      </IconBox>

      <StyledInput
        value={value}
        autoCapitalize="none"
        spellCheck={false}
        type="text"
        enterKeyHint="search"
        autoComplete="off"
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />

      {value?.length > 0 && (
        <ClearButton type="button" aria-label="清除" onClick={() => onClear?.()}>
          <X size={18} color={theme.colors?.secondaryText || "#a2a8af"} />
        </ClearButton>
      )}
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 10px;
  border-radius: 20px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.background};
`

const IconBox = styled.div`
  display: flex;
  align-items: center;
  padding-right: 8px;
  flex-shrink: 0;
`

const StyledInput = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};

  &::-webkit-search-cancel-button,
  &::-webkit-search-decoration {
    -webkit-appearance: none;
    appearance: none;
    display: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.secondaryText};
  }
`

const ClearButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 0 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
`
